/**
 * Canonical Telugu Legal Content for MyTownly Rides (Passenger App).
 * Privacy Policy, Terms of Service, and Safety Guidelines in Telugu (తెలుగు).
 *
 * Notice Version: 2026-10-02
 * Last Updated: 2 October 2026
 */

export const LEGAL_LAST_UPDATED_TE = '2 అక్టోబర్ 2026';
export const LEGAL_VERSION_TE = '2026-10-02';

const OPERATOR_BLOCK_TE = [
  'MyTownly ప్రస్తుతం ఆంధ్రప్రదేశ్, అన్నమయ్య జిల్లా, పీలేరులో “MyTownly” ట్రేడింగ్ పేరుతో ఏకైక యజమాని (sole proprietor)గా షేక్ బదుల్లా ద్వారా నిర్వహించబడుతోంది.',
  'మేము “MyTownly Private Limited”ను నమోదు చేసే ప్రక్రియలో ఉన్నాము. నమోదు పూర్తయిన తర్వాత, వ్యాపారం మరియు ఈ పత్రాలలో వివరించిన బాధ్యతలు ఆ కంపెనీకి బదిలీ చేయబడతాయి మరియు ఈ పత్రం నవీకరించబడుతుంది.',
  'రిజిస్టర్డ్ / నిర్వహణ చిరునామా: JWXV+8J3, కొత్తపల్లి రోడ్, బోడుమల్లువారిపల్లె, పీలేరు, అన్నమయ్య జిల్లా, ఆంధ్రప్రదేశ్ – 517214.',
  'ఫిర్యాదుల అధికారి & గోప్యతా సంప్రదింపు: షేక్ బదుల్లా.',
  'ఫోన్ / WhatsApp: +91 79890 20222 · ఇమెయిల్: hello@mytownly.in',
];

export const LEGAL_DOCS_TE = {
  privacy: {
    title: 'గోప్యతా విధానం (Privacy Policy)',
    subtitle: 'మీరు MyTownly ప్యాసింజర్ యాప్‌ను ఉపయోగించినప్పుడు MyTownly మీ వ్యక్తిగత డేటాను ఎలా సేకరిస్తుంది, ఉపయోగిస్తుంది, పంచుకుంటుంది మరియు రక్షిస్తుంది.',
    lastUpdated: LEGAL_LAST_UPDATED_TE,
    version: LEGAL_VERSION_TE,
    sections: [
      {
        id: 'about',
        title: '1. మీ డేటాకు ఎవరు బాధ్యులు',
        content: [
          'MyTownly అనేది భారతదేశంలోని ఆంధ్రప్రదేశ్, పీలేరు మరియు పరిసర ప్రాంతాలలో ప్రయాణికులను స్వతంత్ర ఆటో-రిక్షా డ్రైవర్లు (“అన్నలు”)తో అనుసంధానించే ఒక సాంకేతిక వేదిక (టెక్నాలజీ ప్లాట్‌ఫారమ్).',
          'భారతదేశ డిజిటల్ వ్యక్తిగత డేటా రక్షణ చట్టం, 2023 (“DPDP చట్టం”) ప్రకారం, MyTownly Passenger App కోసం డేటా ఫిడ్యూషియరీ (డేటా నిర్వాహకులు):',
          ...OPERATOR_BLOCK_TE,
        ],
      },
      {
        id: 'collected',
        title: '2. మేము సేకరించే సమాచారం',
        content: [
          'రైడ్‌లు అందించడానికి, మిమ్మల్ని సురక్షితంగా ఉంచడానికి, మీ ఖాతాను నిర్వహించడానికి మరియు మా చట్టపరమైన బాధ్యతలను నెరవేర్చడానికి అవసరమైన సమాచారాన్ని మాత్రమే మేము సేకరిస్తాము.',
        ],
        table: {
          headers: ['సమాచారం', 'మేము దీనిని ఎందుకు ఉపయోగిస్తాము'],
          rows: [
            ['మొబైల్ నంబర్', 'OTP లాగిన్, ఖాతా భద్రత, రైడ్ మరియు భద్రతా అప్‌డేట్‌లు'],
            ['పేరు (మరొకరి కోసం బుక్ చేస్తే వారి పేరు)', 'ట్రిప్ సమయంలో అన్న‌కు రైడర్‌ను గుర్తించడానికి'],
            ['పికప్ మరియు డ్రాప్ లొకేషన్లు, సేవ్ చేసిన ప్రదేశాలు (ఇల్లు / ఆఫీస్)', 'బుకింగ్, మార్గం, ఛార్జీ లెక్కింపు మరియు డ్రైవర్ మ్యాచింగ్'],
            ['పరికర లొకేషన్ (యాప్ తెరిచి ఉన్నప్పుడు మాత్రమే)', 'మీ పికప్ పాయింట్ సెట్ చేయడానికి మరియు సమీపంలోని అన్నలను చూపించడానికి'],
            ['ట్రిప్ చరిత్ర — స్థితి, మార్గం, ఛార్జీ, రేటింగ్‌లు, ఇన్-యాప్ చాట్', 'రసీదులు, రేటింగ్‌లు, కస్టమర్ సపోర్ట్, వివాదాలు, భద్రత మరియు అవసరమైన రికార్డులు'],
            ['రద్దు మరియు నో-షో చరిత్ర', 'మా ప్రచురిత రద్దు విధానాన్ని న్యాయంగా అమలు చేయడానికి'],
            ['పుష్ నోటిఫికేషన్ టోకెన్', 'రైడ్ స్థితి మరియు భద్రతా నోటిఫికేషన్‌లు పంపడానికి'],
            ['ఎమర్జెన్సీ కాంటాక్ట్‌లు (ఐచ్ఛికం)', 'SOS మరియు ట్రిప్ భద్రతా హెచ్చరికల కోసం'],
            ['సమ్మతి రికార్డులు మరియు గోప్యతా ప్రాధాన్యతలు', 'మీరు దేనికి ఎప్పుడు అంగీకరించారో పారదర్శకంగా ఉంచడానికి'],
            ['పరికరం మరియు యాప్ సమాచారం, సుమారు లొకేషన్', 'మోసాల నివారణ, డయాగ్నస్టిక్స్ మరియు యాప్ వినియోగ విశ్లేషణలు'],
          ],
        },
      },
      {
        id: 'usage',
        title: '3. మీ డేటాను మేము ఎలా ఉపయోగిస్తాము',
        content: [
          'మీ డేటాను క్రింది ప్రయోజనాల కోసం ఉపయోగించవచ్చు:',
          '• మీ ఖాతాను సృష్టించడం, సురక్షితం చేయడం మరియు మీ ఫోన్ నంబర్‌ను ధృవీకరించడం.',
          '• అందుబాటులో ఉన్న అన్నతో మిమ్మల్ని జత చేయడం మరియు పికప్ లొకేషన్‌ను సెట్ చేయడం.',
          '• ప్రయాణ మార్గాలను లెక్కించడం, ముందస్తు పారదర్శక ఛార్జీని చూపించడం మరియు లైవ్ ట్రిప్‌కు మద్దతు ఇవ్వడం.',
          '• బుకింగ్, అన్న రాక, ట్రిప్ స్థితి మరియు భద్రతా నోటిఫికేషన్‌లను పంపడం.',
          '• మా రద్దు విధానాన్ని అమలు చేయడం (ఏదైనా రద్దు రుసుమును లెక్కించడం మరియు తదుపరి రైడ్ తర్వాత క్లియర్ చేయడం).',
          '• మీరు స్వచ్ఛందంగా జోడించే ఐచ్ఛిక ఫేర్ బూస్ట్ (Fare Boost)ను ప్రాసెస్ చేయడం.',
          '• కస్టమర్ సపోర్ట్ అందించడం, రేటింగ్‌లు, ఫీడ్‌బ్యాక్ మరియు వివాదాలను పరిష్కరించడం.',
          '• మోసాలు, దుర్వినియోగం మరియు భద్రతా ముప్పులను గుర్తించి నివారించడం.',
          '• అత్యవసర SOS మరియు ఇతర రక్షణ ఫీచర్లను నిర్వహించడం.',
          '• చట్టపరమైన, అకౌంటింగ్, భద్రత మరియు పన్ను రికార్డులను చట్టం ప్రకారం నిర్వహించడం.',
          '• సేవలను మెరుగుపరచడానికి యాప్ వినియోగాన్ని సమిష్టిగా (aggregate) అర్థం చేసుకోవడం.',
          'మేము మీ వ్యక్తిగత డేటాను ప్రకటనదారులకు లేదా డేటా బ్రోకర్లకు ఎప్పటికీ విక్రయించము, అద్దెకు ఇవ్వము లేదా వ్యాపారం చేయము.',
        ],
      },
      {
        id: 'legal_basis',
        title: '4. మా చట్టపరమైన ప్రాతిపదిక',
        content: [
          '• రైడ్, ఖాతా మరియు భద్రతా ప్రాసెసింగ్ చాలావరకు మీరు కోరిన సేవను అందించడానికి మరియు మాకు వర్తించే చట్టపరమైన బాధ్యతలను నెరవేర్చడానికి అవసరం.',
          '• అత్యవసర కాంటాక్ట్‌లను జోడించడం, అనలిటిక్స్ లేదా ప్రచార సందేశాల వంటి ఐచ్ఛిక ఫీచర్లు మీ సమ్మతిపై ఆధారపడి ఉంటాయి. మీరు ఎప్పుడైనా మీ సమ్మతిని ఉపసంహరించుకోవచ్చు.',
          '• కొన్ని రికార్డులు (ఉదాహరణకు ట్రిప్ మరియు పన్ను రికార్డులు) చట్టం ప్రకారం నిర్దిష్ట కాలం పాటు తప్పనిసరిగా భద్రపరచబడతాయి.',
        ],
      },
      {
        id: 'location',
        title: '5. లొకేషన్ మరియు GPS',
        content: [
          'లొకేషన్ అనేది MyTownly అనుభవానికి అత్యంత ప్రధానమైనది.',
          '• మీ లొకేషన్: మీరు లొకేషన్ ఫీచర్లను ఉపయోగిస్తున్నప్పుడు మాత్రమే మేము లొకేషన్ యాక్సెస్‌ను అడుగుతాము — బుకింగ్ మ్యాప్, సమీపంలోని అన్నలను చూపించడం, రూటింగ్ మరియు యాక్టివ్ ట్రిప్. మీరు యాప్‌ను మూసివేసిన తర్వాత మేము బ్యాక్‌గ్రౌండ్‌లో మీ లొకేషన్‌ను ఎప్పటికీ ట్రాక్ చేయము.',
          '• పికప్ పిన్: మీరు నిర్ధారించిన పికప్ పాయింట్ మీ కేటాయించిన అన్నతో షేర్ చేయబడుతుంది.',
          '• ట్రిప్ సమయంలో మీ మ్యాప్‌లో కదిలే ఆటో మీ అన్న యొక్క లైవ్ లొకేషన్, ఆ ట్రిప్ వ్యవధి వరకు మాత్రమే మీకు కనిపిస్తుంది. ఇది మీ లొకేషన్ కాదు.',
          'మీరు లొకేషన్ అనుమతిని నిరాకరిస్తే, కొన్ని ఫీచర్లు సరిగ్గా పనిచేయకపోవచ్చు.',
        ],
      },
      {
        id: 'driver_info',
        title: '6. మీ అన్న గురించి సమాచారం',
        content: [
          'రైడ్ కేటాయించబడినప్పుడు, మీరు మీ రైడ్‌ను సులభంగా గుర్తించి సురక్షితంగా ప్రయాణించడానికి పరిమిత సమాచారాన్ని మేము చూపిస్తాము:',
          '• అన్న పేరు, ప్రొఫైల్ ఫోటో మరియు రేటింగ్.',
          '• వాహనం మోడల్, రంగు మరియు రిజిస్ట్రేషన్ నంబర్ (నంబర్ ప్లేట్).',
          '• యాక్టివ్ ట్రిప్ సమయంలో మ్యాప్‌లో అన్న యొక్క లైవ్ లొకేషన్.',
        ],
      },
      {
        id: 'shared_with_driver',
        title: '7. మీ అన్నతో పంచుకోబడే సమాచారం',
        content: [
          'రైడ్‌ను సాధ్యం చేయడానికి, మేము మీ కేటాయించిన అన్నతో క్రింది వివరాలను పంచుకుంటాము:',
          '• మీ పేరు (లేదా రైడర్ పేరు), పికప్ లొకేషన్ & చిరునామా మరియు డ్రాప్ లొకేషన్.',
          '• ట్రిప్ వివరాలు మరియు ఇన్-యాప్ చాట్ ద్వారా మీరు పంపే సందేశాలు.',
          'మీ వ్యక్తిగత ఫోన్ నంబర్ అన్న‌కు నేరుగా బహిర్గతం చేయబడదు.',
        ],
      },
      {
        id: 'otp',
        title: '8. ట్రిప్-ప్రారంభ OTP',
        content: [
          'ప్రతి రైడ్ యాప్‌లో మీకు చూపబడే 4-అంకెల ప్రారంభ OTP ద్వారా రక్షించబడుతుంది.',
          'రైడ్ ప్రారంభించడానికి అన్న మీ నుండి ఈ OTPని పొంది యాప్‌లో నమోదు చేయాలి. సరైన వాహనంలో మీరు సురక్షితంగా కూర్చున్న తర్వాత మాత్రమే కేటాయించిన అన్నతో OTPని పంచుకోండి.',
        ],
      },
      {
        id: 'safety',
        title: '9. భద్రతా ఫీచర్లు మరియు రక్షణ బృందం',
        content: [
          '• అత్యవసర SOS: రైడ్ సమయంలో మీరు SOS బటన్ నొక్కినప్పుడు, మీ ట్రిప్ మరియు లొకేషన్ వివరాలతో అత్యవసర హెచ్చరిక జారీ చేయబడుతుంది. మీ సేవ్ చేసిన అత్యవసర కాంటాక్ట్‌లకు లైవ్ ట్రాకింగ్ లింక్‌తో హెచ్చరిక వెళుతుంది మరియు తక్షణ సహాయం కోసం MyTownly అంతర్గత భద్రతా బృందానికి కూడా చేరుతుంది.',
          '• అత్యవసర హెల్ప్‌లైన్: మీ పరికరం మద్దతిస్తే, భారతదేశ అత్యవసర నంబర్ 112 కు 1-ట్యాప్ యాక్సెస్ అందించబడుతుంది.',
          '• లైవ్ ట్రిప్ షేరింగ్: మీరు తాత్కాలిక ట్రాకింగ్ లింక్‌ను రూపొందించి మీ కుటుంబ సభ్యులు లేదా మిత్రులతో పంచుకోవచ్చు. రైడ్ ముగిసిన వెంటనే ఆ లింక్ గడువు ముగుస్తుంది.',
          '• ఎమర్జెన్సీ కాంటాక్ట్‌లు: మీరు గరిష్టంగా ముగ్గురు విశ్వసనీయ వ్యక్తులను జోడించవచ్చు మరియు ఎప్పుడైనా వారిని తొలగించవచ్చు.',
        ],
      },
      {
        id: 'cancellation_data',
        title: '10. రద్దు రుసుము డేటా',
        content: [
          'మా ప్రచురిత విధానం ప్రకారం మీ ఖాతాకు రద్దు రుసుము వర్తిస్తే (నిబంధనలు & షరతులు చూడండి), మేము బకాయి మొత్తం మరియు ఇటీవలి ఆలస్యపు రద్దుల సంఖ్యను మీ ఖాతాలో నమోదు చేస్తాము.',
          'ఆ బకాయి మొత్తం మీ తదుపరి బుకింగ్ ఛార్జీలో చూపబడుతుంది మరియు ఆ రైడ్ పూర్తయిన తర్వాత ఆటోమేటిక్‌గా క్లియర్ చేయబడుతుంది.',
        ],
      },
      {
        id: 'payments',
        title: '11. చెల్లింపులు',
        content: [
          'MyTownly రైడ్‌లకు ప్రయాణం ముగిసిన తర్వాత నేరుగా అన్న‌కు నగదు రూపంలో చెల్లిస్తారు. మేము మీ బ్యాంక్ ఖాతా, డెబిట్/క్రెడిట్ కార్డ్ లేదా UPI వివరాలను సేకరించము లేదా నిల్వ చేయము.',
          'యాప్‌లో కనిపించే ఏదైనా UPI ఐడెంటిఫైయర్ అన్నలు MyTownly ప్లాట్‌ఫారమ్ బకాయిలను చెల్లించడానికి మాత్రమే ఉద్దేశించబడింది; అది ప్రయాణికుల చెల్లింపుల కోసం కాదు.',
        ],
      },
      {
        id: 'third_parties',
        title: '12. సర్వీస్ ప్రొవైడర్లు మరియు డేటా ప్రాసెసింగ్',
        content: [
          'యాప్‌ను నమ్మకంగా నడపడానికి మేము విశ్వసనీయ సేవా భాగస్వాములను ఉపయోగిస్తాము:',
          '• Google Firebase — ప్రమాణీకరణ, డేటాబేస్, ఫైల్ స్టోరేజ్, హోస్టింగ్, క్లౌడ్ ఫంక్షన్స్ మరియు పుష్ నోటిఫికేషన్‌లు. మీ ఖాతా, రైడ్ రికార్డులు మరియు ఫోటోలు గూగుల్ యొక్క ముంబై, భారతదేశం రీజియన్‌లో భద్రపరచబడతాయి.',
          '• Google Firebase Realtime Database — ట్రిప్ సమయంలో లైవ్ లొకేషన్ రిలే. ఈ భాగం సింగపూర్ రీజియన్‌లో హోస్ట్ చేయబడింది, కాబట్టి లైవ్-ట్రిప్ డేటా ట్రిప్ వ్యవధిలో భారతదేశం వెలుపల ప్రాసెస్ చేయబడుతుంది.',
          '• Google Analytics for Firebase — మొత్తం యాప్ వినియోగ విశ్లేషణ.',
          '• Google Maps Platform — మ్యాప్‌లు, ప్రదేశాలు, జియోకోడింగ్ మరియు రూటింగ్.',
          '• Google reCAPTCHA — లాగిన్ సమయంలో స్వయంచాలక దుర్వినియోగం నుండి రక్షణ.',
          '• Truecaller (Android) — వేగవంతమైన ఫోన్ వెరిఫికేషన్ (ఎల్లప్పుడూ OTP లాగిన్ ప్రత్యామ్నాయంగా ఉంటుంది).',
          '• మీ పరికర తయారీదారు పుష్ సర్వీస్ — నోటిఫికేషన్‌లను డెలివరీ చేయడం.',
          'DPDP చట్టం ప్రకారం భారత ప్రభుత్వం పరిమితం చేయని దేశాలకు మాత్రమే క్రాస్-బోర్డర్ డేటా బదిలీ జరుగుతుంది. ఈ ప్రొవైడర్లు తమ సేవను అందించడానికి అవసరమైన డేటాను మాత్రమే ప్రాసెస్ చేస్తారు.',
        ],
      },
      {
        id: 'retention',
        title: '13. డేటా నిల్వ వ్యవధి',
        content: [
          'సేకరించిన ప్రయోజనం నెరవేరే వరకు మాత్రమే మేము వ్యక్తిగత డేటాను ఉంచుతాము, ఆ తర్వాత దానిని తొలగిస్తాము లేదా అనామకంగా (anonymise) మారుస్తాము:',
          '• ఖాతా ప్రొఫైల్: మీ ఖాతా తొలగించబడే వరకు.',
          '• రైడ్ రికార్డులు (మార్గం, ఛార్జీ, రేటింగ్‌లు, చాట్): రసీదులు, వివాదాలు, భద్రత మరియు పన్నుల కోసం సుమారు 3 సంవత్సరాలు.',
          '• SOS మరియు భద్రతా లాగ్‌లు, లొకేషన్ లాగ్‌లు: సుమారు 90 రోజులు.',
          '• ట్రిప్ సమయంలోని లైవ్ GPS పాయింట్లు: ట్రిప్ ముగిసిన సుమారు 30 నిమిషాల్లోపు డేటాబేస్ నుండి పూర్తిగా తొలగించబడతాయి.',
          '• లాగిన్ మరియు భద్రతా లాగ్‌లు: సుమారు 1 సంవత్సరం.',
          '• ఖాతా తొలగింపు తర్వాత: మీ ప్రత్యక్ష గుర్తింపు వివరాలు 30 రోజుల్లోపు తొలగించబడతాయి; చట్టం ప్రకారం భద్రపరచాల్సిన రైడ్ వివరాలు అనామక రూపంలో ఉంచబడతాయి.',
        ],
      },
      {
        id: 'security',
        title: '14. డేటా భద్రత',
        content: [
          'మీ డేటాను రక్షించడానికి మేము బలమైన సాంకేతిక రక్షణలను (సర్వర్-సైడ్ ధృవీకరణ, యాక్సెస్ రూల్స్, ఎన్‌క్రిప్టెడ్ HTTPS రవాణా, రేట్ లిమిటింగ్) ఉపయోగిస్తాము.',
          'ఏ ఇంటర్నెట్ సేవ కూడా 100% భద్రతకు హామీ ఇవ్వలేదు. చట్టం ప్రకారం నోటిఫికేషన్ అవసరమయ్యే డేటా ఉల్లంఘన జరిగితే, మేము డేటా ప్రొటెక్షన్ బోర్డ్ ఆఫ్ ఇండియా మరియు ప్రభావిత వినియోగదారులకు తెలియజేస్తాము.',
        ],
      },
      {
        id: 'rights',
        title: '15. మీ హక్కులు (DPDP చట్టం ప్రకారం)',
        content: [
          'చట్టం ప్రకారం మీకు ఈ క్రింది హక్కులు ఉన్నాయి:',
          '• మేము మీ గురించి కలిగి ఉన్న వ్యక్తిగత డేటా సారాంశాన్ని తెలుసుకునే హక్కు.',
          '• తప్పు లేదా అసంపూర్ణ డేటాను సరిదిద్దే లేదా నవీకరించే హక్కు.',
          '• మీ వ్యక్తిగత డేటాను తొలగించాలని కోరే హక్కు (చట్టం ప్రకారం అవసరమైన రికార్డులకు లోబడి).',
          '• ఐచ్ఛిక ప్రాసెసింగ్ కోసం ఇచ్చిన సమ్మతిని ఉపసంహరించుకునే హక్కు.',
          '• మరణం లేదా అసమర్థత సందర్భంలో మీ హక్కులను వినియోగించుకోవడానికి మరొక వ్యక్తిని నామినేట్ చేసే హక్కు.',
          '• ఫిర్యాదు చేసి పరిష్కారం పొందే హక్కు.',
          'యాప్‌లోని ప్రొఫైల్ → గోప్యత & చట్టపరమైనవి ఉపయోగించండి లేదా క్రింది ఫిర్యాదుల అధికారిని సంప్రదించండి. మేము 30 రోజుల్లోపు స్పందిస్తాము.',
        ],
      },
      {
        id: 'deletion',
        title: '16. మీ ఖాతాను తొలగించడం',
        content: [
          'మీరు మీ MyTownly ఖాతాను ఎప్పుడైనా శాశ్వతంగా తొలగించవచ్చు:',
          'ప్రొఫైల్ → గోప్యత & చట్టపరమైనవి → ఖాతాను తొలగించండి (Delete Account)',
          'మీరు hello@mytownly.in కు ఇమెయిల్ చేయడం ద్వారా కూడా సహాయం పొందవచ్చు. మీ ఖాతా తొలగించబడినప్పుడు మీ లాగిన్ మరియు ప్రొఫైల్ వివరాలు తొలగించబడతాయి.',
        ],
      },
      {
        id: 'children',
        title: '17. పిల్లల రక్షణ',
        content: [
          'MyTownly 18 సంవత్సరాలు మరియు అంతకంటే ఎక్కువ వయస్సు ఉన్నవారి కోసం మాత్రమే ఉద్దేశించబడింది. ఖాతా సృష్టించినప్పుడు మీకు 18+ వయస్సు ఉందని మీరు నిర్ధారిస్తారు.',
          'మేము పిల్లల వ్యక్తిగత డేటాను ఉద్దేశపూర్వకంగా సేకరించము. ఎవరైనా పిల్లలు మాకు డేటా అందించారని మీరు భావిస్తే, hello@mytownly.in కు తెలియజేయండి, మేము దానిని తొలగిస్తాము.',
        ],
      },
      {
        id: 'changes',
        title: '18. ఈ విధానంలో మార్పులు',
        content: [
          'మా సేవ, సాంకేతికత లేదా చట్టపరమైన అవసరాలు మారినప్పుడు మేము ఈ గోప్యతా విధానాన్ని నవీకరించవచ్చు. ముఖ్యమైన మార్పులు చేసినప్పుడు యాప్‌లో నోటీసు ఇస్తాము.',
        ],
      },
      {
        id: 'grievance',
        title: '19. ఫిర్యాదుల పరిష్కారం మరియు సంప్రదింపు',
        content: [
          'ఏదైనా గోప్యతా ప్రశ్న, డేటా అభ్యర్థన లేదా ఫిర్యాదు కోసం, మా ఫిర్యాదుల అధికారిని సంప్రదించండి:',
          ...OPERATOR_BLOCK_TE,
          'మేము 48 గంటల్లోగా ఫిర్యాదులను స్వీకరించి, 30 రోజుల్లోగా పరిష్కరించడానికి ప్రయత్నిస్తాము.',
        ],
      },
    ],
  },

  terms: {
    title: 'నిబంధనలు & షరతులు (Terms of Service)',
    subtitle: 'మీరు MyTownlyని ఉపయోగించినప్పుడు వర్తించే నియమాలు, బాధ్యతలు, ఛార్జీలు మరియు రద్దు విధానం.',
    lastUpdated: LEGAL_LAST_UPDATED_TE,
    version: LEGAL_VERSION_TE,
    sections: [
      {
        id: 'platform',
        title: '1. MyTownly మరియు ఈ నిబంధనల గురించి',
        content: [
          'MyTownly అనేది భారతదేశంలోని ఆంధ్రప్రదేశ్, పీలేరు మరియు పరిసర ప్రాంతాలలో ప్రయాణికులను స్వతంత్ర ఆటో-రిక్షా డ్రైవర్లు (“అన్నలు”)తో అనుసంధానించే ఒక సాంకేతిక వేదిక.',
          'MyTownly బుకింగ్ సాంకేతికతను మాత్రమే అందిస్తుంది. రవాణా సేవను వాహనం నడిపే స్వతంత్ర అన్న అందిస్తారు. MyTownly రవాణా ఆపరేటర్ కాదు మరియు ఆటో-రిక్షాలను స్వంతం చేసుకోదు లేదా నడపదు.',
          'ఈ నిబంధనలు మీకు మరియు MyTownly నిర్వాహకులకు మధ్య ఒప్పందాన్ని ఏర్పరుస్తాయి:',
          ...OPERATOR_BLOCK_TE,
          'ఖాతాను సృష్టించడం ద్వారా లేదా రైడ్‌ను అభ్యర్థించడం ద్వారా, మీరు ఈ నిబంధనలను మరియు గోప్యతా విధానాన్ని అంగీకరిస్తున్నారు. మీకు అంగీకారం లేకపోతే, దయచేసి సేవను ఉపయోగించవద్దు.',
        ],
      },
      {
        id: 'eligibility',
        title: '2. అర్హత మరియు మీ ఖాతా',
        content: [
          '• ఖాతాను సృష్టించడానికి మరియు రైడ్‌లను బుక్ చేయడానికి మీకు కనీసం 18 సంవత్సరాలు నిండి ఉండాలి.',
          '• మీరు OTPలను స్వీకరించగల చెల్లుబాటు అయ్యే భారతీయ మొబైల్ నంబర్‌ను మరియు ఖచ్చితమైన సమాచారాన్ని అందించాలి.',
          '• మీ ఖాతాలో జరిగే కార్యకలాపాలకు మరియు మీ పరికరాన్ని సురక్షితంగా ఉంచుకోవడానికి మీరే బాధ్యులు.',
          '• ఒక వ్యక్తికి ఒకే ఖాతా అనుమతించబడుతుంది. ఇతరుల ఖాతాను ఉపయోగించవద్దు లేదా చట్టవిరుద్ధమైన ప్రయోజనాల కోసం యాప్‌ను ఉపయోగించవద్దు.',
          '• ఈ నిబంధనలను ఉల్లంఘించే లేదా భద్రతా ప్రమాదాన్ని కలిగించే ఖాతాను సస్పెండ్ చేసే లేదా పరిమితం చేసే హక్కు మాకు ఉంది.',
        ],
      },
      {
        id: 'service',
        title: '3. MyTownly ఏమి చేస్తుంది మరియు ఏమి చేయదు',
        content: [
          '• MyTownly మీ రైడ్ అభ్యర్థనను అందుబాటులో ఉన్న అన్నతో జత చేస్తుంది మరియు ట్రిప్ టెక్నాలజీని (మ్యాప్, OTP, చాట్, లైవ్ ట్రాకింగ్, భద్రతా సాధనాలు) అందిస్తుంది.',
          '• MyTownly స్వయంగా రవాణాను అందించదు, అన్నలను ఉద్యోగులుగా నియమించదు మరియు ప్రతి అభ్యర్థనకు తప్పనిసరిగా అన్న అందుబాటులో ఉంటారని హామీ ఇవ్వదు.',
          '• చూపబడే రాక సమయాలు మరియు ఛార్జీలు అంచనాలు మాత్రమే; దూరం, ట్రాఫిక్ మరియు వాతావరణ పరిస్థితుల ఆధారంగా మారవచ్చు.',
        ],
      },
      {
        id: 'fares',
        title: '4. బుకింగ్, ఛార్జీలు మరియు చెల్లింపు',
        content: [
          '• పికప్ మరియు డ్రాప్ వివరాలను నమోదు చేయడం ద్వారా రైడ్‌ను బుక్ చేయండి. మీరు నిర్ధారించే ముందు యాప్ వర్తించే ఛార్జీని స్పష్టంగా చూపిస్తుంది.',
          '• ఛార్జీలో బేస్ ఫేర్, కనీస ఛార్జీ, దూరపు ఛార్జీలు మరియు వర్తించే ఇతర చట్టబద్ధమైన ఛార్జీలు ఉంటాయి.',
          '• రైడ్ ముగిసిన తర్వాత అన్న‌కు నేరుగా నగదు రూపంలో చెల్లింపు చేయాలి. టోల్‌లు లేదా పార్కింగ్ ఛార్జీలు ఉంటే ప్రయాణికుడే చెల్లించాలి.',
          '• ఫేర్ బూస్ట్ (ఐచ్ఛికం): రద్దీ సమయాల్లో అన్నను త్వరగా ఆకర్షించడానికి మీరు స్వచ్ఛందంగా అదనపు మొత్తాన్ని జోడించవచ్చు. ఇది మీరు స్వయంగా ఎంచుకునేది — MyTownly ఎలాంటి సర్జ్ ప్రైసింగ్ విధించదు.',
          '• వెయిటింగ్ ఛార్జీ (బుకింగ్ స్క్రీన్‌లో చూపినప్పుడు): మీ అన్న మీ పికప్ పాయింట్‌కు చేరుకున్న తర్వాత మీరు అతడిని వేచి ఉంచితే, మొదటి కొన్ని నిమిషాలు ఉచితం; ఆ తర్వాత నిమిషానికి చిన్న ఛార్జీ వర్తిస్తుంది, ప్రతి బుకింగ్‌కు గరిష్ట మొత్తం పరిమితి ఉంటుంది. ఉచిత సమయం, రేటు మీరు నిర్ధారించే ముందు బుకింగ్ స్క్రీన్‌లో చూపబడతాయి, బుక్ చేయడం ద్వారా మీరు వాటిని అంగీకరిస్తారు. మీ అన్న మీ పికప్ పాయింట్‌కు చేరిన క్షణం నుండి మీ ట్రిప్ PIN అంగీకరించబడే వరకు వేచి ఉన్న సమయం లెక్కించబడుతుంది. వెయిటింగ్ ఛార్జీ మొత్తం ఫేర్‌తో కలిపి నగదుగా అన్నకు చెల్లించబడుతుంది. ఈ నిబంధనలు మీకు చూపించిన బుకింగ్‌లకు మాత్రమే వర్తిస్తుంది.',
          '• ఏ అన్న కూడా మీ అభ్యర్థనను అంగీకరించకపోతే, అది శోధిస్తూ ఉండి సుమారు 8 నిమిషాల తర్వాత ఆటోమేటిక్‌గా రద్దవుతుంది, తద్వారా మీరు మళ్లీ బుక్ చేసుకోవచ్చు. అన్న దొరకని శోధనకు ఎలాంటి రద్దు రుసుము ఉండదు.',
        ],
      },
      {
        id: 'cancellations',
        title: '5. రద్దులు మరియు రద్దు రుసుములు',
        content: [
          'ట్రిప్ ప్రారంభమయ్యే ముందు మీరు ఎప్పుడైనా రైడ్ అభ్యర్థనను రద్దు చేయవచ్చు. మా రద్దు విధానం మీకు మరియు మీ కోసం వచ్చే అన్నకు ఇద్దరికీ న్యాయంగా రూపొందించబడింది:',
          '• ఉచిత రద్దు: ఏ అన్న కూడా అంగీకరించకముందు (శోధన సమయంలో), లేదా అన్న అంగీకరించిన 2 నిమిషాల్లోపు రద్దు చేస్తే 100% ఉచితం.',
          '• మొదటిసారి ఆలస్యపు రద్దు (2 నిమిషాల తర్వాత): ఉచితం (తదుపరిసారి రుసుము వర్తిస్తుందనే ఒకే ఒక్క రిమైండర్‌తో).',
          '• తర్వాతి ప్రతి ఆలస్యపు రద్దు (అన్న ఇప్పటికే బయలుదేరినప్పుడు లేదా పికప్ వద్దకు చేరుకున్నప్పుడు): ₹10 రుసుము వర్తిస్తుంది (ఎప్పుడైనా గరిష్టంగా ₹20 బకాయిలు మాత్రమే ఉంటాయి).',
          '• ఏదైనా బకాయి ఉన్న రద్దు రుసుము మీ తదుపరి రైడ్ ఛార్జీకి జోడించబడుతుంది మరియు ఆ అన్నకు నగదుగా చెల్లించబడుతుంది. ఆ రైడ్ పూర్తయిన వెంటనే మీ ఖాతా నుండి రుసుము క్లియర్ అవుతుంది.',
          '• సరైన కారణాలు ఉంటే (ఉదాహరణకు అన్న కదలకుండా ఉండటం, రద్దు చేయమని కోరడం): మా కస్టమర్ సపోర్ట్‌ను సంప్రదిస్తే మేము పరిశీలిస్తాము.',
          '• పదేపదే ఉద్దేశపూర్వకంగా రద్దు చేయడం లేదా నకిలీ బుకింగ్‌లు చేయడం ఖాతా పరిమితులకు దారితీయవచ్చు.',
        ],
      },
      {
        id: 'responsibilities',
        title: '6. ప్రయాణికుడిగా మీ బాధ్యతలు',
        content: [
          'MyTownlyని ఉపయోగిస్తున్నప్పుడు మీరు ఈ క్రింది వాటికి అంగీకరిస్తున్నారు:',
          '• ఖచ్చితమైన పికప్ మరియు డ్రాప్ వివరాలను నమోదు చేయడం మరియు పికప్ పాయింట్ వద్ద సిద్ధంగా ఉండటం.',
          '• వాహనం ఎక్కే ముందు అన్న, ఆటో మరియు నంబర్ ప్లేట్ వివరాలు యాప్‌తో సరిపోలుతున్నాయో లేదో తనిఖీ చేయడం.',
          '• ట్రిప్-స్టార్ట్ OTPని మీ కేటాయించిన అన్నతో మాత్రమే పంచుకోవడం.',
          '• అన్న మరియు ఇతరులతో మర్యాదగా ప్రవర్తించడం — ఎటువంటి బెదిరింపులు, వేధింపులు లేదా వివక్ష ఉండరాదు.',
          '• వాహనాన్ని పాడుచేయకుండా ఉండటం మరియు నిషేధిత, ప్రమాదకరమైన వస్తువులను తీసుకెళ్లకపోవడం.',
        ],
      },
      {
        id: 'drivers_safety',
        title: '7. అన్న, వాహనం మరియు భద్రత',
        content: [
          '• అన్నలు చెల్లుబాటు అయ్యే డ్రైవింగ్ లైసెన్స్, వాహన పర్మిట్, ఫిట్‌నెస్ సర్టిఫికెట్ మరియు బీమా కలిగి ఉండటానికి మరియు చట్టాలను పాటించడానికి స్వయంగా బాధ్యులైన స్వతంత్ర ఆపరేటర్లు.',
          '• MyTownly ఆన్‌బోర్డింగ్ తనిఖీలను (గుర్తింపు మరియు వాహన ఫోటోలు, రిజిస్ట్రేషన్ వివరాలు) నిర్వహిస్తుంది, అయితే రవాణా సేవను అందించేది అన్న మాత్రమే.',
          '• అత్యవసర సమయాల్లో మాత్రమే SOSను ఉపయోగించండి. మీకు అభద్రతగా అనిపిస్తే, సురక్షితమైన ప్రదేశంలో రైడ్‌ను ముగించి అత్యవసర సేవలను సంప్రదించండి.',
        ],
      },
      {
        id: 'ratings',
        title: '8. రేటింగ్‌లు మరియు ఫీడ్‌బ్యాక్',
        content: [
          'రైడ్ తర్వాత మీరు మీ అన్నకు రేటింగ్ ఇవ్వవచ్చు మరియు ఫీడ్‌బ్యాక్ తెలియజేయవచ్చు. రేటింగ్‌లు సేవను నాణ్యంగా ఉంచడంలో సహాయపడతాయి. తప్పుడు లేదా దురుద్దేశపూర్వక రేటింగ్‌లను ఇవ్వవద్దు.',
        ],
      },
      {
        id: 'prohibited',
        title: '9. నిషేధిత ప్రవర్తన',
        content: [
          'మీరు ఈ క్రింది పనుల కోసం MyTownlyని ఉపయోగించకూడదు:',
          '• ఏదైనా చట్టవిరుద్ధమైన కార్యకలాపాలను నిర్వహించడం.',
          '• ఇతరులను బెదిరించడం, వేధించడం లేదా హాని కలిగించడం.',
          '• తప్పుడు సమాచారాన్ని అందించడం లేదా ఇతరుల పేర్లతో నటించడం.',
          '• ప్లాట్‌ఫారమ్‌ను రివర్స్-ఇంజనీర్ చేయడం, స్క్రాప్ చేయడం లేదా హ్యాక్ చేయడానికి ప్రయత్నించడం.',
        ],
      },
      {
        id: 'termination',
        title: '10. సస్పెన్షన్ మరియు ముగింపు',
        content: [
          '• మీరు ఎప్పుడైనా MyTownly వినియోగాన్ని ఆపివేయవచ్చు మరియు మీ ఖాతాను తొలగించవచ్చు.',
          '• మీరు ఈ నిబంధనలను ఉల్లంఘించినా, మోసాలకు పాల్పడినా లేదా భద్రతా ప్రమాదాన్ని సృష్టించినా మీ ఖాతా యాక్సెస్‌ను తాత్కాలికంగా నిలిపివేసే లేదా శాశ్వతంగా ముగించే హక్కు మాకు ఉంది.',
        ],
      },
      {
        id: 'liability',
        title: '11. సేవా లభ్యత మరియు బాధ్యత పరిమితి',
        content: [
          '• MyTownlyని నిరంతరం నమ్మకంగా అందించడానికి మేము కృషి చేస్తాము, అయితే నెట్‌వర్క్, GPS, ట్రాఫిక్ లేదా వాతావరణం వంటి మా నియంత్రణలో లేని అంశాల వల్ల సేవకు అంతరాయం కలగవచ్చు.',
          '• రవాణా సేవను స్వతంత్ర అన్న అందిస్తారు, ట్రిప్ మరియు వాహన నిర్వహణకు అన్నదే పూర్తి బాధ్యత.',
          '• చట్టం అనుమతించిన మేరకు, పరోక్ష నష్టాలకు MyTownly బాధ్యత వహించదు. బాధ్యత వర్తించే సందర్భంలో మా మొత్తం బాధ్యత సంబంధిత రైడ్ ఛార్జీ లేదా ₹1,000 కు పరిమితం చేయబడుతుంది.',
        ],
      },
      {
        id: 'ip',
        title: '12. మేధో సంపత్తి (Intellectual Property)',
        content: [
          'MyTownly యాప్, వెబ్‌సైట్, బ్రాండ్, “MyTownly” మరియు “Anna” పేర్లు, లోగోలు మరియు కంటెంట్ MyTownly యొక్క స్వంతం. అనుమతి లేకుండా వాటిని కాపీ చేయడం, సవరించడం లేదా పంపిణీ చేయడం నిషిద్ధం.',
        ],
      },
      {
        id: 'grievance',
        title: '13. ఫిర్యాదుల పరిష్కారం',
        content: [
          'భారతదేశ వినియోగదారుల రక్షణ నిబంధనలు మరియు ఐటీ నిబంధనల ప్రకారం, మా ఫిర్యాదుల అధికారి:',
          ...OPERATOR_BLOCK_TE,
          'మేము 48 గంటల్లోగా ఫిర్యాదులను స్వీకరించి, 30 రోజుల్లోగా పరిష్కరించడానికి ప్రయత్నిస్తాము.',
        ],
      },
      {
        id: 'changes',
        title: '14. నిబంధనలలో మార్పులు',
        content: [
          'మా సేవ, ఫీచర్లు, ధరలు లేదా చట్టపరమైన అవసరాలు మారినప్పుడు మేము ఈ నిబంధనలను నవీకరించవచ్చు. ముఖ్యమైన మార్పులను యాప్‌లో తెలియజేస్తాము. మార్పుల తర్వాత సేవను ఉపయోగించడం అంటే మీరు నవీకరించిన నిబంధనలను అంగీకరించినట్లే.',
        ],
      },
      {
        id: 'governing_law',
        title: '15. పాలక చట్టం మరియు వివాదాలు',
        content: [
          'ఈ నిబంధనలు భారతదేశ చట్టాల ద్వారా నిర్వహించబడతాయి.',
          'వివాదాలపై ఆంధ్రప్రదేశ్, అన్నమయ్య జిల్లా, పీలేరు న్యాయస్థానాలకు మరియు అక్కడి పరిధి లేకపోతే రాయచోటి జిల్లా కోర్టుకు అధికార పరిధి ఉంటుంది. వినియోగదారుల రక్షణ చట్టం, 2019 ప్రకారం వినియోగదారుల ఫోరమ్‌ను ఆశ్రయించే మీ హక్కుకు ఇది ఆటంకం కలిగించదు.',
        ],
      },
      {
        id: 'contact',
        title: '16. సంప్రదించండి',
        content: [
          'MyTownly · ఇమెయిల్: hello@mytownly.in · ఫోన్ / WhatsApp: +91 79890 20222 · JWXV+8J3, కొత్తపల్లి రోడ్, బోడుమల్లువారిపల్లె, పీలేరు, అన్నమయ్య జిల్లా, ఆంధ్రప్రదేశ్ – 517214.',
        ],
      },
    ],
  },

  safety: {
    title: 'భద్రత & అత్యవసర మార్గదర్శకాలు (Safety Guidelines)',
    subtitle: 'MyTownly ప్రతి రైడ్‌ను ఎలా సురక్షితంగా ఉంచుతుంది — మరియు అత్యవసర సమయాల్లో ఏమి చేయాలి.',
    lastUpdated: LEGAL_LAST_UPDATED_TE,
    version: LEGAL_VERSION_TE,
    sections: [
      {
        id: 'otp_verification',
        title: '1. 4-అంకెల ట్రిప్-స్టార్ట్ OTP',
        content: [
          'ప్రతి రైడ్‌కు మీ స్క్రీన్‌పై ఒక ప్రత్యేకమైన 4-అంకెల ప్రారంభ OTP కనిపిస్తుంది.',
          'వాహనం ఎక్కే ముందు ఆటో నంబర్ ప్లేట్ యాప్‌తో సరిపోలుతుందో లేదో తనిఖీ చేయండి, మరియు మీరు సురక్షితంగా సరైన ఆటోలో కూర్చున్న తర్వాత మాత్రమే అన్నతో OTPని పంచుకోండి.',
        ],
      },
      {
        id: 'sos_feature',
        title: '2. అత్యవసర SOS',
        content: [
          'యాక్టివ్ రైడ్ సమయంలో SOS బటన్ ఎల్లప్పుడూ అందుబాటులో ఉంటుంది. మీరు దానిని నొక్కినప్పుడు:',
          '• మీ లైవ్ లొకేషన్ మరియు ట్రిప్ వివరాలు క్యాప్చర్ చేయబడి అత్యవసర హెచ్చరిక జారీ చేయబడుతుంది.',
          '• మీ సేవ్ చేసిన అత్యవసర కాంటాక్ట్‌లకు లైవ్ ట్రాకింగ్ లింక్‌తో WhatsApp/SMS హెచ్చరిక వెళుతుంది.',
          '• తక్షణ ప్రతిస్పందన కోసం హెచ్చరిక MyTownly భద్రతా బృందానికి చేరుతుంది.',
          '• మీ పరికరం మద్దతిస్తే, 112 (పోలీస్) మరియు 108 (అంబులెన్స్)కు 1-ట్యాప్ యాక్సెస్ కూడా లభిస్తుంది.',
        ],
      },
      {
        id: 'trip_share',
        title: '3. లైవ్ ట్రిప్ షేరింగ్',
        content: [
          'సురక్షితమైన తాత్కాలిక లింక్‌ను సృష్టించడానికి యాక్టివ్ రైడ్ స్క్రీన్‌పై “ట్రిప్ షేర్ చేయండి” (Share Trip) నొక్కండి.',
          'మీరు పంపిన వ్యక్తి యాప్ ఇన్‌స్టాల్ చేయకుండానే మ్యాప్‌లో మీ ఆటో కదలికను నిజ సమయంలో చూడవచ్చు. ఈ లింక్ మీ ఫోన్ నంబర్‌ను బహిర్గతం చేయదు మరియు రైడ్ ముగిసిన వెంటనే ముగుస్తుంది.',
        ],
      },
      {
        id: 'verified_captains',
        title: '4. ధృవీకరించబడిన స్థానిక అన్నలు',
        content: [
          'అన్నలు రైడ్‌లను అంగీకరించే ముందు గుర్తింపు మరియు వాహన ఫోటోలు, రిజిస్ట్రేషన్ వివరాలు మరియు ప్లాట్‌ఫారమ్ బ్రీఫింగ్‌తో కూడిన ఆన్‌బోర్డింగ్ తనిఖీలను పూర్తి చేస్తారు.',
        ],
      },
      {
        id: 'good_practice',
        title: '5. మంచి భద్రతా పద్ధతులు',
        content: [
          '• సురక్షితమైన, వెలుతురు ఉన్న ప్రదేశంలో మీ రైడ్ కోసం వేచి ఉండండి.',
          '• ఎక్కే ముందు అన్న, ఫోటో, వాహన మోడల్ మరియు నంబర్ ప్లేట్ యాప్‌తో సరిపోలుతున్నాయో లేదో చూసుకోండి.',
          '• రాత్రి సమయాల్లో లేదా తెలియని మార్గాల్లో ప్రయాణించేటప్పుడు మీ ట్రిప్‌ను కుటుంబ సభ్యులతో పంచుకోండి.',
          '• మీ అంతర్ దృష్టిని నమ్మండి — ఏదైనా అనుమానాస్పదంగా అనిపిస్తే, సురక్షితమైన ప్రదేశంలో రైడ్‌ను ముగించి సహాయం కోసం కాల్ చేయండి.',
        ],
      },
    ],
  },
};
